export default __webpack_public_path__ + "static/media/logo.a24a7748.png";